import React from 'react';
import { Hero } from '../components/Hero';
import { Stats } from '../components/Stats';
import { Services } from '../components/Services';
import { Events } from '../components/Events';
import { PilotInfo } from '../components/PilotInfo';
import { Contact } from '../components/Contact';
export function HomePage() {
  return <>
      <Hero data-id="element-553" />
      <Stats data-id="element-554" />
      <Services data-id="element-555" />
      <Events data-id="element-556" />
      <PilotInfo data-id="element-557" />
      <Contact data-id="element-558" />
    </>;
}